import ReadersAndIntercomIcon from "../../assets/product-list-assets/readers-and-intercom.svg";
import type { ProductListGroup } from "../../types";

export const readersAndIntercom: ProductListGroup = {
  id: "readersAndIntercom",
  title: "productListGroup.readersAndIntercom.title",
  icon: {
    src: ReadersAndIntercomIcon,
    width: 20,
    height: 20,
  },
};
